import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../../../global.service';
import { Service } from '../../../../../services';
import { LoadingScreenService } from '../../../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-pop-up-terms-offers',
  templateUrl: './pop-up-terms-offers.component.html',
  styleUrls: ['./pop-up-terms-offers.component.sass']
})
export class PopUpTermsOffersComponent implements OnInit {
  public offer:any;
  public screenActual=1;
  public emailReceiver;
  constructor(public matDialogRef:MatDialogRef<PopUpTermsOffersComponent>,public dialog: MatDialog, private services: Service, private global: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any,) {
    this.offer=data.offer;
  }
  ngOnInit() {
  }
  close(){
    this.matDialogRef.close('cancel');
  }
}

